import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Logo } from '@/design-system';
import { ThemeToggle } from '@/app/ThemeToggle';
import { useApplicantSession } from '@/lib/applicant/useApplicantSession';
import styles from './ApplicantLayout.module.css';
import { YourData } from './YourData';

/**
 * The frame of every applicant page: the brand, the theme, and who is signed in.
 *
 * Not the staff AppShell, whose navigation is a list of back-office pages an
 * applicant may not open. An applicant has one thing to do here.
 */
export function ApplicantLayout({ children }: { children: ReactNode }) {
  const { applicant, signOut } = useApplicantSession();
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Container>
          <div className={styles.headerInner}>
            <Link to="/" className={styles.brand}>
              <Logo />
            </Link>
            <div className={styles.tools}>
              {applicant && (
                <>
                  <span className={styles.who}>{applicant.email}</span>
                  <Button variant="ghost" size="sm" onClick={signOut}>
                    Sign out
                  </Button>
                </>
              )}
              <ThemeToggle />
            </div>
          </div>
        </Container>
      </header>
      <main className={styles.main}>{children}</main>
      {applicant && (
        <footer className={styles.footer}>
          <Container>
            <YourData />
          </Container>
        </footer>
      )}
    </div>
  );
}
